// <your existing imports> (unchanged)
import React, {
  useCallback,
  useMemo,
  useRef,
  useEffect,
  useState,
} from "react";
import dagre from "dagre";
import { useLocation } from "react-router-dom";
import { useGetHierarchyQuery } from "../redux/organizationApi";
import { toast } from "react-toastify";
import {
  clearSelectedNodes,
  selectSelectedNodes,
} from "../redux/selectedNodesSlice";

import NodeDetailSelectorModal from "../components/NodeDetailSelectorModal";
import { Box, TextField, Typography } from "@mui/material";
import { getNodesBounds, getViewportForBounds } from "reactflow";
import DownloadButton from "./DownloadButton";
import { setSelectedNodes } from "../redux/selectedNodesSlice";
import Checkbox from "@mui/material/Checkbox";
import ReactFlow, {
  Background,
  Controls,
  Panel,
  MiniMap,
  useNodesState,
  useEdgesState,
  useReactFlow,
} from "reactflow";
import "reactflow/dist/style.css";
import TextUpdaterNode from "../components/TextUpdaterNode";
import {
  Addnodepositioned,
  selectMinusButtonClick,
  selectPlusButtonClick,
  selectPlusNodeIdClick,
  setMinusClicked,
  setPlusClicked,
} from "../redux/nodePositionedSlice";
import { useDispatch, useSelector } from "react-redux";
import { Addedgepositioned } from "../redux/edgesPositionedSlice";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import { autoTable } from 'jspdf-autotable'
import GenerateReportSelectorModal from "../components/GenerateReportSelectorModal";
import getHongKongTimestamp from "../utils/getHongKongTime";
import { toPng , toJpeg} from "html-to-image";
import { fields } from "../components/data";
import "./index.css";


// Layout constants
const nodeWidth = 450;
const nodeHeight = 250;
// Default focus id will now come from API `rootId`; keep a null fallback
let DEFAULT_FOCUS_ID = null;

// Camera/viewport constants
const MAX_ZOOM = 0.8;
const MIN_ZOOM = 0.001;
const VIEWPORT_PADDING = 0.12;
const TARGET_SCREEN_VERTICAL_FRACTION = 0.45;

const getLayoutedElements = (nodes, rawEdges, direction = "TB") => {
  if (!nodes?.length) return { nodes: [], edges: [] };

  // Format nodes using the formatNodes utility if they're raw API data
  // const nodes = rawNodes.map((org) => {
  //   if (org.type === "custom") {
  //     return org;
  //   }

  //   // Otherwise format from raw API data - create new object only when necessary
  //   return {
  //     id: org?._id?.toString() || org?.id?.toString(),
  //     _id: org?._id?.toString() || org?.id?.toString(),
  //     type: "custom",
  //     hidden: false,
  //     expanded: true,
  //     data: {
  //       nodeId: org?._id || org?.id,
  //       _id: org?._id || org?.id,
  //       label: org?.companyName,
  //       companyName: org?.companyName,
  //       location: org?.location,
  //       // orgchild: org?.children?.filter((item) => item.isBranch === false),
  //       children: org?.children?.filter((item) => item.isBranch === false),
  //       totalNoOfShares: org?.totalNoOfShares,
  //       directors: org?.directors || [],
  //       shareHolders: org?.shareHolders,
  //       additionalFields: org?.additionalFields,
  //       BusinessNature: org?.BusinessNature,
  //       Incorporationdate: org?.Incorporationdate,
  //       CompanyRegistrationNumber: org?.CompanyRegistrationNumber,
  //       BusinessRegistrationNumber: org?.BusinessRegistrationNumber,
  //       ManagingDirector: org?.ManagingDirector,
  //       DeputyManagingDirector: org?.DeputyManagingDirector,
  //       Chairman: org?.Chairman,
  //       ResidentDirector: org?.ResidentDirector,
  //       DeputyChairman: org?.DeputyChairman,
  //       CompanySecretary: org?.CompanySecretary,
  //       StatutoryAuditor: org?.StatutoryAuditor,
  //       RepresentativeDirector: org?.RepresentativeDirector,
  //       LegalRepresentative: org?.LegalRepresentative,
  //       TotalPaidUpCapital: org?.TotalPaidUpCapital,
  //       registerCurrency: org?.registerCurrency,
  //       ParCurrency: org?.ParCurrency,
  //       CapitalCurrency: org?.CapitalCurrency,
  //       TotalCurrency: org?.TotalCurrency,
  //       Remarks: org?.Remarks,
  //       AuthorizedCapital: org?.AuthorizedCapital,
  //       ParValueofShares: org?.ParValueofShares,
  //       TotalPaidUpPremiumtoShares: org?.TotalPaidUpPremiumtoShares,
  //       totalIssuedPreferenceShares: org?.totalIssuedPreferenceShares,
  //       PercentageOfShares: org?.PercentageOfShares,
  //       BusinessGroup: org?.BusinessGroup,
  //       isBranch: org?.isBranch,
  //       isOperatingCompany: org?.isOperatingCompany,
  //       jointcompany: org?.jointcompany,
  //       isJointVentureCompany: org?.isJointVentureCompany,
  //       JointVentureCompanies: org?.JointVentureCompanies,
  //       Address: org?.Address,
  //       parent: org?.parent,
  //       children: org?.children,
  //       checked: org?.checked,
  //       branch: org?.branch,
  //     },
  //     children: org?.children,
  //     Address: org?.Address,
  //     parent: org?.parent,
  //     isRoot: org?.isRoot,
  //     checked: org?.checked,
  //     isBranch: org?.isBranch,
  //     isOperatingCompany: org?.isOperatingCompany,
  //     isJointVentureCompany: org?.isJointVentureCompany,
  //     JointVentureCompanies: org?.JointVentureCompanies,
  //     placelocation: org?.location,
  //     location: org?.location,
  //     possssss: { xdata: org?.position?.x, ydata: org?.position?.y },
  //     position: { x: 0, y: 0 }, // Will be set by Dagre
  //   };
  // });

  // Format edges if needed - reuse existing edge objects when possible

  const edges = (rawEdges || []).map((edge) => {
    // Reuse existing edge if it's already properly formatted
    if (edge.source && edge.target && edge.id) return edge;
    // Only create new object when necessary
    return {
      id: `e-${edge.source?.toString()}-${edge.target?.toString()}`,
      source: edge.source?.toString(),
      target: edge.target?.toString(),
      type: "step",
    };
  });

  // Create Dagre graph
  const dagreGraph = new dagre.graphlib.Graph();
  dagreGraph.setDefaultEdgeLabel(() => ({}));
  dagreGraph.setGraph({
    rankdir: direction,
    nodesep: 300, // Horizontal spacing between nodes
    ranksep: 200, // Vertical spacing between ranks/levels
    marginx: 50,
    marginy: 50,
  });

  // Set nodes in Dagre
  nodes.forEach((node) => {
    dagreGraph.setNode(node.id, { width: nodeWidth, height: nodeHeight });
  });

  // Set edges in Dagre
  edges.forEach((edge) => {
    if (edge.source && edge.target) {
      dagreGraph.setEdge(edge.source, edge.target);
    }
  });

  // Run Dagre layout algorithm
  dagre.layout(dagreGraph);

  // Apply calculated positions to nodes - reuse node objects when position unchanged
  const layoutedNodes = nodes.map((node) => {
    const nodeWithPosition = dagreGraph.node(node.id);

    // Check if node has custom saved position
    const hasCustomPosition =
      node.possssss?.xdata !== undefined &&
      node.possssss?.ydata !== undefined &&
      node.possssss?.xdata !== null &&
      node.possssss?.ydata !== null;

    // Use custom position if available, otherwise use Dagre calculated position
    const newPosition = hasCustomPosition
      ? { x: node.possssss.xdata, y: node.possssss.ydata }
      : nodeWithPosition
        ? {
          x: nodeWithPosition.x - nodeWidth / 2,
          y: nodeWithPosition.y - nodeHeight / 2,
        }
        : { x: 0, y: 0 };

    // Only create new object if position actually changed
    if (
      node.position?.x === newPosition.x &&
      node.position?.y === newPosition.y
    ) {
      return node; // Reuse existing object
    }

    return {
      ...node,
      position: newPosition,
    };
  });

  return {
    nodes: layoutedNodes,
    edges: edges,
  };
};

// Memoize D3_View component to prevent unnecessary re-renders
// fitOnMountKey: when this changes (coming back from edit / after reset),
// we auto-call fitView once after the graph is ready.
const D3_ViewComponent = ({ fitOnMountKey }) => {
  const { data, isLoading: fetchingNodes, isError } = useGetHierarchyQuery();
  console.log("data in d3 view", data?.viewPermission);
  const dispatch = useDispatch();
  const reactFlowInstance = useReactFlow();
  const plusButton = useSelector(selectPlusButtonClick);
  const clickedNodeId = useSelector(selectPlusNodeIdClick);
  const minusButton = useSelector(selectMinusButtonClick);
  const selectedNodes = useSelector(selectSelectedNodes);
  const location = useLocation();
  const [reportingModalOpen, setReportingModalOpen] = useState(false);
  const handleReportingModalClose = () => setReportingModalOpen(false);
  const selectedNodesForReport = useSelector(selectSelectedNodes);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  // NEW: visual stage flags and progress
  const [renderingNodes, setRenderingNodes] = useState(false);
  const [layouting, setLayouting] = useState(false);
  const [focusing, setFocusing] = useState(false);
  const [displaying, setDisplaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [expectedNodeCount, setExpectedNodeCount] = useState(0);
  const [graphReady, setGraphReady] = useState(false);

  // Mounted ref for cleanup
  const isMountedRef = useRef(true);
  // Track all timeouts/intervals for cleanup
  const timeoutRefs = useRef([]);
  const intervalRefs = useRef([]);
  const rafRef = useRef(null);
  const searchTimeoutRef = useRef(null);
  const renderedDoneRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
      // Cleanup all pending timeouts
      timeoutRefs.current.forEach((timeoutId) => {
        if (timeoutId) clearTimeout(timeoutId);
      });
      timeoutRefs.current = [];
      // Cleanup all intervals
      intervalRefs.current.forEach((intervalId) => {
        if (intervalId) clearInterval(intervalId);
      });
      intervalRefs.current = [];
      // cancel RAF
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
        searchTimeoutRef.current = null;
      }
    };
  }, []);

  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  useEffect(() => {
    const isReportGenerated = searchParams.get('report-generating');

    if (isReportGenerated === "true") {
      searchParams.delete('report-generating');
      const newUrl = window.location.pathname + (searchParams.toString() ? `?${searchParams.toString()}` : '');
      window.history.replaceState({}, '', newUrl);
      const selecteds = nodes?.map((node) => node.data);

      if (selecteds?.length > 0) {
        dispatch(setSelectedNodes(selecteds));
        setIsAllSelected(true);
      }

      setReportingModalOpen(true);
    }
  }, [location.key, dispatch, searchParams]);

  const { nodes: layoutedNodes, edges: layoutedEdges } = useMemo(() => {
    if (!data?.nodes || !data?.edges) {
      return { nodes: [], edges: [] };
    }
    // pure computation only – no setState here
    return getLayoutedElements(data.nodes, data.edges, "TB");
  }, [data]);

  // mark layouting when fresh data arrives; reset ready flags
  useEffect(() => {
    if (!data?.nodes || !data?.edges) return;
    renderedDoneRef.current = false;
    setGraphReady(false);
    setProgress(0);
    setLayouting(true);
  }, [data]);

  // Track expected node count to measure rendering progress
  useEffect(() => {
    if (Array.isArray(layoutedNodes)) {
      setExpectedNodeCount(layoutedNodes.length);
    } else {
      setExpectedNodeCount(0);
    }
  }, [layoutedNodes]);

  // Use ReactFlow state hooks for nodes and edges (enables setNodes/setEdges)
  const [nodes, setNodes, onNodesChange] = useNodesState(layoutedNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(layoutedEdges);

  // When layoutedNodes changes we set nodes — mark rendering start and poll DOM
  useEffect(() => {
    if (!isMountedRef.current) return;
    if (!layoutedNodes || layoutedNodes.length === 0) return;

    // new render cycle: reset flags
    renderedDoneRef.current = false;
    setGraphReady(false);
    // switch from "layouting" to "rendering"
    setLayouting(false);
    setRenderingNodes(true);
    setProgress((p) => Math.max(p, 45)); // move to layout->render transition
    // set nodes which triggers React to render DOM
    setNodes(layoutedNodes);

    // now poll DOM to see how many .react-flow__node are present
    const start = Date.now();
    const maxWait = 3000; // ms fallback
    const tick = () => {
      if (!isMountedRef.current) return;
      const expected = expectedNodeCount || layoutedNodes.length || 1;
      const renderedCount =
        document.querySelectorAll?.(".react-flow__node").length || 0;
      // map rendered ratio to a progress range [45 .. 92]
      const renderedRatio = Math.min(1, renderedCount / Math.max(1, expected));
      const percent = Math.round(45 + renderedRatio * (92 - 45));
      setProgress((p) => Math.max(p, percent));
      if (renderedCount >= expected || Date.now() - start > maxWait) {
        // done rendering (or timeout)
        renderedDoneRef.current = true;
        setRenderingNodes(false);
        setProgress(92);
        return;
      }
      rafRef.current = requestAnimationFrame(tick);
    };
    // kick it
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(tick);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layoutedNodes, expectedNodeCount, setNodes]);

  // Update edges whenever layoutedEdges changes
  useEffect(() => {
    if (!isMountedRef.current) return;
    if (!layoutedEdges || layoutedEdges.length === 0) return;
    setEdges(layoutedEdges);
  }, [layoutedEdges, setEdges]);

  useEffect(() => {
    if (fetchingNodes) {
      // starting fetch
      setProgress(5);
      setGraphReady(false);
      renderedDoneRef.current = false;
    } else {
      // fetch finished -> nudge a bit forward but do not jump too much
      setProgress((p) => (p < 15 ? 15 : p));
    }
  }, [fetchingNodes]);

  // Layouting stage watcher (already toggled in useMemo)
  // (optional) could add gentle time-based increments per stage here, but
  // core progress is now driven by actual render measurements in the tick()

  // If all stages are false but progress not 100, finalize
  useEffect(() => {
    if (
      !fetchingNodes &&
      !layouting &&
      !renderingNodes &&
      !focusing &&
      !displaying &&
      renderedDoneRef.current
    ) {
      setProgress(100);
      // wait 1 second so the bar visually reaches 100% before hiding
      const t = setTimeout(() => {
        if (!isMountedRef.current) return;
        setGraphReady(true);
      }, 1000);
      timeoutRefs.current.push(t);
    }
  }, [fetchingNodes, layouting, renderingNodes, focusing, displaying]);

  // Safety guard: if progress is high but graph is still not marked ready,
  // force-complete after a short delay so the loader never gets stuck
  useEffect(() => {
    if (graphReady) return;
    if (progress < 92) return;

    const t = setTimeout(() => {
      if (!isMountedRef.current) return;
      setGraphReady(true);
      setProgress(100);
      setLayouting(false);
      setRenderingNodes(false);
      setFocusing(false);
      setDisplaying(false);
    }, 2000);

    timeoutRefs.current.push(t);
  }, [progress, graphReady]);

  // After graph is ready AND we've just come from edit/reset (fitOnMountKey),
  // mimic the React Flow Controls "fit view" behavior once.
  useEffect(() => {
    if (!graphReady) return;
    if (!fitOnMountKey) return;
    if (!reactFlowInstance || typeof reactFlowInstance.fitView !== "function")
      return;

    try {
      reactFlowInstance.fitView({ duration: 400 });
    } catch {
      // ignore runtime fitView errors
    }
  }, [graphReady, fitOnMountKey, reactFlowInstance]);

  // (rest of your existing callback functions unchanged) ...
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => setOpen(false), []);
  const [searchValue, setSearchValue] = useState("");

  const formatHeaderLabel = useCallback((label) => {
    const findLabel = fields.find((field) => field.id === label);
    return findLabel
      ? findLabel.label
      : label
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (str) => str.toUpperCase())
        .trim();
  }, []);

  const htmlToPlainText = useCallback((html) => {
    const plainText = html?.replace(/<[^>]*>/g, "");
    const cleanText = plainText?.replace(/&[^;]+;/g, "");
    const words = cleanText?.split(/\s+/);
    const first100Words = words?.slice(0, 20).join(" ");

    return first100Words;
  }, []);

  const exportGraphAsPDF = useCallback(async () => {
    const bounds = getNodesBounds(nodes);
    const imageWidth = 140000;
    const imageHeight = 50000;
    const viewport = getViewportForBounds(
      bounds,
      imageWidth,
      imageHeight,
      5,
      15
    );

    const node = document.querySelector(".react-flow__viewport");
    if (!node) return;

    const dataUrl = await toPng(node, {
      backgroundColor: "white",
      width: imageWidth,
      height: imageHeight,
      style: {
        width: imageWidth + "px",
        height: imageHeight + "px",
        transform: `translate(${viewport.x}px, ${viewport.y}px) scale(${viewport.zoom})`,
      },
    });

    const pdfWidth = 1400; // px
    const scaleFactor = pdfWidth / imageWidth;
    const pdfHeight = imageHeight * scaleFactor;

    const pdf = new jsPDF({
      orientation: "landscape",
      unit: "px",
      format: [pdfWidth, pdfHeight],
    });

    pdf.addImage(dataUrl, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`chart_image_${getHongKongTimestamp()}.pdf`);
  }, [nodes]);

    const downloadImage = (dataUrl, fileName) => {
    const link = document.createElement("a"); // Create a temporary link
    link.href = dataUrl; // Set the image URL
    link.download = fileName; // Set the file name
    document.body.appendChild(link); // Append link to body
    link.click(); // Trigger download
    document.body.removeChild(link); // Remove link
  };

 async function downloadPDF(dataUrl) {
    return await new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        try {
          const imgWidth = img.width;
          const imgHeight = img.height;
          console.log("image width= ", imgWidth, ", imageHeight= ", imgHeight);

          // Keep high resolution in PDF
          const maxPdfWidth = 5000;
          const scale = imgWidth > maxPdfWidth ? maxPdfWidth / imgWidth : 1;
          const pdfW = Math.round(imgWidth * scale);
          const pdfH = Math.round(imgHeight * scale);

          console.log("scale", scale);
          console.log("Pdf Width", pdfW);
          console.log("pdfH", pdfH);

          const pdf = new jsPDF({
            orientation: pdfW > pdfH ? "landscape" : "portrait",
            unit: "px",
            format: [pdfW + 80, pdfH + 20],
          });

          pdf.addImage(dataUrl, "PNG", 10, 10, pdfW, pdfH);
          pdf.save(`chart_image_${getHongKongTimestamp()}.pdf`);
          resolve();
        } catch (err) {
          reject(err);
        }
      };
      img.onerror = () => reject(new Error("Failed to load image"));
      img.src = dataUrl;
    });
  }
  const getVisibleNodesInViewport = useCallback(() => {
    const allNodes = reactFlowInstance.getNodes();
    const viewport = reactFlowInstance.getViewport();

    const container = document.querySelector(".react-flow");
    if (!container) return allNodes.filter((n) => !n.hidden);

    const containerRect = container.getBoundingClientRect();
    const containerWidth = containerRect.width;
    const containerHeight = containerRect.height;

    const viewportMinX = -viewport.x / viewport.zoom;
    const viewportMinY = -viewport.y / viewport.zoom;
    const viewportMaxX = viewportMinX + containerWidth / viewport.zoom;
    const viewportMaxY = viewportMinY + containerHeight / viewport.zoom;

    const visibleNodes = allNodes.filter((node) => {
      if (node.hidden) return false;

      const nodeX = node.position?.x ?? 0;
      const nodeY = node.position?.y ?? 0;
      const nodeRight = nodeX + nodeWidth;
      const nodeBottom = nodeY + nodeHeight;

      const isVisible =
        nodeRight >= viewportMinX &&
        nodeX <= viewportMaxX &&
        nodeBottom >= viewportMinY &&
        nodeY <= viewportMaxY;

      return isVisible;
    });

    return visibleNodes;
  }, [reactFlowInstance.getNodes(), reactFlowInstance.getViewport()]);

  const onDownload = useCallback(async () => {
    if (isExporting) return;
    setIsExporting(true);

    // Store original node states for restoration
    let originalNodeStates = null;

    try {
      if (!reactFlowInstance.fitView || typeof reactFlowInstance.fitView !== "function") {
        setIsExporting(false);
        return;
      }

      // Ensure react-flow container is loaded in DOM before starting download
      const reactFlowEl = document.querySelector(".react-flow");
      if (!reactFlowEl) {
        throw new Error("ReactFlow container not found in DOM");
      }

      // Wait for the react-flow instance to be fully rendered
      await new Promise((resolve) => requestAnimationFrame(resolve));
      await new Promise((resolve) => setTimeout(resolve, 100));

      // Get selected node IDs
      const selectedNodeIds = new Set(
        (selectedNodes || [])
          .map((node) => String(node?.nodeId || node?.id || node?._id || ""))
          .filter(Boolean)
      );

      // If no nodes selected, show error
      if (selectedNodeIds.size === 0) {
        toast.error("Please select at least one node to download");
        setIsExporting(false);
        return;
      }

      // Hide unselected nodes before capture
      if (setNodes && selectedNodeIds.size > 0) {
        const allNodes = reactFlowInstance.getNodes();
        originalNodeStates = new Map(
          allNodes.map((node) => [node.id, node.hidden])
        );

        // Hide unselected nodes
        setNodes((prevNodes) =>
          prevNodes.map((node) => {
            const nodeId = String(node.id || node._id || "");
            const isSelected = selectedNodeIds.has(nodeId);
            return {
              ...node,
              hidden: !isSelected,
            };
          })
        );

        // Wait for DOM to update
        await new Promise((resolve) => requestAnimationFrame(resolve));
        await new Promise((resolve) => setTimeout(resolve, 50));
      }

      // Wait for fitView to complete before capturing
      try {
        reactFlowInstance.fitView({ duration: 400 });
      } catch {
        // ignore runtime fitView errors
      }

      // Wait for animation to complete
      await new Promise((resolve) => setTimeout(resolve, 450));

      const visibleNodes = getVisibleNodesInViewport();
      console.log("Visible nodes in viewport:", visibleNodes.length);

      if (!visibleNodes || visibleNodes.length === 0) {
        // Restore nodes before returning
        if (originalNodeStates && setNodes) {
          setNodes((prevNodes) =>
            prevNodes.map((node) => ({
              ...node,
              hidden: originalNodeStates.get(node.id) ?? false,
            }))
          );
        }
        toast.error("No visible nodes in viewport to export");
        setIsExporting(false);
        return;
      }

      // Get the react-flow container (already verified above)
      const captureElement = document.querySelector(".react-flow");
      if (!captureElement) {
        throw new Error("ReactFlow container not found");
      }

      const rect = captureElement.getBoundingClientRect();
      const captureWidth = Math.round(rect.width);
      const captureHeight = Math.round(rect.height);
      const nodeCount = visibleNodes.length;

      console.log(
        "Capturing:",
        captureWidth,
        "x",
        captureHeight,
        "with",
        nodeCount,
        "nodes"
      );

      // Hide UI elements
      const hideSelectors = [
        ".react-flow__controls",
        ".react-flow__minimap",
        ".react-flow__panel",
        ".react-flow__attribution",
        ".react-flow__background",
      ];

      const hiddenElements = [];
      hideSelectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => {
          const prev = el.style.visibility;
          el.style.visibility = "hidden";
          hiddenElements.push({ el, prev });
        });
      });

      await new Promise((r) => requestAnimationFrame(r));

      // VERY HIGH pixel ratio for maximum quality
      // This creates a much larger image for crisp text
      // pixelRatio;

      let pixelRatio = 12;
      // if (nodeCount <= 35) {
      // } else if (nodeCount <= 150) {
      //   pixelRatio = 12;
      // } else if (nodeCount <= 500) {
      //   pixelRatio = 12;
      // } else if (nodeCount <= 1000) {
      //   pixelRatio = 18;
      // } else {
      //   pixelRatio = 19;
      // }

      console.log(
        "Using pixel ratio:",
        pixelRatio,
        "-> Output:",
        captureWidth * pixelRatio,
        "x",
        captureHeight * pixelRatio
      );

      // Capture at very high resolution
      const dataUrl = await toJpeg(captureElement, {
        backgroundColor: "#ffffff",
        width: captureWidth,
        height: captureHeight,
        pixelRatio: pixelRatio,
        cacheBust: true,
        quality: 1.0,
        filter: (node) => {
          if (node.classList) {
            return !(
              node.classList.contains("react-flow__controls") ||
              node.classList.contains("react-flow__minimap") ||
              node.classList.contains("react-flow__panel") ||
              node.classList.contains("react-flow__attribution") ||
              node.classList.contains("react-flow__background")
            );
          }
          return true;
        },
      });

      // Restore hidden elements
      hiddenElements.forEach(({ el, prev }) => {
        el.style.visibility = prev;
      });

      if (!dataUrl || dataUrl.length < 5000) {
        throw new Error("Generated image appears to be empty");
      }

      console.log(
        "Image generated, size:",
        Math.round((dataUrl.length / 1024 / 1024) * 100) / 100,
        "MB"
      );
      // downloadImage(dataUrl, `chart_image_${getHongKongTimestamp()}.jpg`);
      await downloadPDF(dataUrl);
      console.log("Image downloaded!");
    } catch (err) {
      console.error("Export failed:", err);
      toast.error("Export failed: " + err.message);
    } finally {
      if (originalNodeStates && setNodes) {
        setNodes((prevNodes) =>
          prevNodes.map((node) => ({
            ...node,
            hidden: originalNodeStates.get(node.id) ?? false,
          }))
        );
      }
      document
        .querySelectorAll(
          ".react-flow__controls, .react-flow__minimap, .react-flow__panel, .react-flow__background"
        )
        .forEach((el) => {
          el.style.visibility = "";
        });
      setIsExporting(false);
    }
  }, [
    getVisibleNodesInViewport,
    isExporting,
    selectedNodes,
    setNodes,
    reactFlowInstance.getNodes,
    reactFlowInstance.fitView,
  ]);

  const reportGeneration = useCallback(
    async (selectedFields) => {
      const selectedNodeIds = selectedNodesForReport?.map(
        (node) => node.nodeId || node.id
      );
      const allorg = nodes?.filter((item) => selectedNodeIds.includes(item.id));

      const filteredData = allorg?.map((item, index) => {
        const rowData = { ID: index + 1 };
        Object.keys(selectedFields)?.forEach((field) => {
          if (selectedFields[field]) {
            if (field === "location") {
              rowData[formatHeaderLabel(field)] =
                item?.data?.[field]?.address || "----";
            } else if (field === "TotalPaidUpCapital") {
              const amount = item?.data?.[field] || 0;
              const currency = item?.data?.TotalCurrency || "";
              const formattedAmount = new Intl.NumberFormat().format(amount);
              rowData[formatHeaderLabel(field)] = currency
                ? `${currency === "USD" ? "$" : currency} ${formattedAmount}`
                : formattedAmount;
            } else if (field === "Remarks") {
              rowData[formatHeaderLabel(field)] = htmlToPlainText(
                item?.data?.[field]
              );
            } else if (field === "directors") {
              rowData[formatHeaderLabel(field)] = Array.isArray(
                item?.data?.[field]
              )
                ? item?.data?.[field].join(", ")
                : item?.data?.[field] || "----";
            } else if (field === "shareholders") {
              const shareHolders = item?.data?.shareHolders || [];
              const jointVentures = item?.data?.JointVentureCompanies || [];

              const shareholderDetails = shareHolders.map((sh) => {
                const childOrg = nodes.find((org) => org.id === sh.childId);
                const companyName = childOrg?.data?.companyName || sh.childId;
                const shares = sh.numberSharesOwned
                  ? Number(sh.numberSharesOwned).toLocaleString()
                  : "0";
                const percentage = Number((sh.PercentageOfShares || 0).toFixed(3))
                return `(${companyName}-${shares}-${percentage}%)`;
              });

              const jointVentureDetails = jointVentures.map((jv) => {
                const shares = jv.numberSharesOwned
                  ? Number(jv.numberSharesOwned).toLocaleString()
                  : "0";
                const percentage = Number((jv.PercentageOfShares || 0).toFixed(3))
                return `(${jv.companyName}[JV]-${shares}-${percentage}%)`;
              });

              const allDetails = [
                ...shareholderDetails,
                ...jointVentureDetails,
              ];
              rowData[formatHeaderLabel(field)] =
                allDetails.length > 0 ? allDetails.join("&&") : "----";
            } else {
              rowData[formatHeaderLabel(field)] = item?.data?.[field] || "----";
            }
          }
        });
        rowData["Operating Company"] = item?.isBranch
          ? item?.data?.companyName?.split("-")[0]?.trim() || "----"
          : "----";
        return rowData;
      });

      // Excel Export
      const worksheet = XLSX.utils.json_to_sheet(filteredData);
      worksheet["!cols"] = Object.keys(selectedFields)
        ?.filter((f) => selectedFields[f])
        ?.map(() => ({ wch: 35 }));
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Companies Report");
      XLSX.writeFile(workbook, `company_report_${getHongKongTimestamp()}.xlsx`);

      // await exportGraphAsPDF();
      await onDownload();
      setReportingModalOpen(false);
    },
    [
      selectedNodesForReport,
      nodes,
      formatHeaderLabel,
      htmlToPlainText,
      onDownload
    ]
  );

  const generateReport = useCallback(
    (selectedFields, exportType) => {
      const selectedNodeIds = selectedNodes?.map(
        (node) => node.nodeId || node.id
      );
      const allorg = nodes?.filter((item) => selectedNodeIds.includes(item.id));

      const filteredData = allorg?.map((item, index) => {
        const rowData = { ID: index + 1 };
        Object.keys(selectedFields)?.forEach((field) => {
          if (selectedFields[field]) {
            if (field === "location") {
              rowData[formatHeaderLabel(field)] =
                item?.data?.[field]?.address || "----";
            }
            else if (field === "TotalPaidUpPremiumtoShares") {
              const amount = item?.data?.[field] || 0;
              const currency = item?.data?.TotalCurrency || "";
              const formattedAmount = new Intl.NumberFormat().format(amount);
              rowData[formatHeaderLabel(field)] = currency
                ? `${currency === "USD" ? "$" : currency} ${formattedAmount}`
                : formattedAmount;
            }
            else if (field === "TotalPaidUpCapital") {
              const amount = item?.data?.[field] || 0;
              const currency = item?.data?.registerCurrency || "";
              const formattedAmount = new Intl.NumberFormat().format(amount);
              rowData[formatHeaderLabel(field)] = currency
                ? `${currency === "USD" ? "$" : currency} ${formattedAmount}`
                : formattedAmount;
            }

            else if (field === "AuthorizedCapital") {
              const amount = item?.data?.[field] || 0;
              const currency = item?.data?.CapitalCurrency || "";
              const formattedAmount = new Intl.NumberFormat().format(amount);
              rowData[formatHeaderLabel(field)] = currency
                ? `${currency === "USD" ? "$" : currency} ${formattedAmount}`
                : formattedAmount;
            }

            else if (field === "ParValueofShares") {
              const amount = item?.data?.[field] || 0;
              const currency = item?.data?.ParCurrency || "";
              const formattedAmount = new Intl.NumberFormat().format(amount);
              rowData[formatHeaderLabel(field)] = currency
                ? `${currency === "USD" ? "$" : currency} ${formattedAmount}`
                : formattedAmount;
            }



            else if (field === "Remarks") {
              rowData[formatHeaderLabel(field)] = htmlToPlainText(
                item?.data?.[field]
              );
            } else if (field === "directors") {
              if (Array.isArray(item?.data?.[field])) {
                rowData[formatHeaderLabel(field)] =
                  item?.data?.[field].join(", ");
              } else {
                rowData[formatHeaderLabel(field)] =
                  item?.data?.[field] || "----";
              }
            } else if (field === "shareholders") {
              const shareHolders = item?.data?.shareHolders || [];
              const jointVentures = item?.data?.JointVentureCompanies || [];

              const shareholderDetails = shareHolders.map((sh) => {
                const childOrg = nodes.find((org) => org.id === sh.childId);
                const companyName = childOrg?.data?.companyName || sh.childId;
                const shares = sh.numberSharesOwned
                  ? Number(sh.numberSharesOwned).toLocaleString()
                  : "0";
                const percentage = Number((sh.PercentageOfShares || 0).toFixed(3))
                return `(${companyName}-${shares}-${percentage}%)`;
              });

              const jointVentureDetails = jointVentures.map((jv) => {
                const shares = jv.numberSharesOwned
                  ? Number(jv.numberSharesOwned).toLocaleString()
                  : "0";
                const percentage = Number((jv.PercentageOfShares || 0).toFixed(3))
                return `(${jv.companyName}[JV]-${shares}-${percentage}%)`;
              });

              const allDetails = [
                ...shareholderDetails,
                ...jointVentureDetails,
              ];
              rowData[formatHeaderLabel(field)] =
                allDetails.length > 0 ? allDetails.join("&&") : "----";
            } else {
              rowData[formatHeaderLabel(field)] = item?.data?.[field] || "----";
            }
          }
        });
        return rowData;
      });

      if (exportType === "Excel") {
        const worksheet = XLSX.utils.json_to_sheet(filteredData);

        const columnWidths = Object.keys(selectedFields)
          ?.filter((field) => selectedFields[field])
          ?.map((field) => {
            switch (field) {
              case "ID":
                return { wch: 10 };
              case "companyName":
              case "Business Group":
              case "Business Nature":
              case "Incorporationdate":
              case "directors":
              case "Chairman":
              case "DeputyChairman":
              case "ManagingDirector":
              case "DeputyManagingDirector":
              case "Representative Director":
              case "ResidentDirector":
              case "LegalRepresentative":
              case "CompanySecretary":
              case "StatutoryAuditor":
              case "AuthorizedCapital":
              case "IssuedPaidUpCapital":
              case "ParValueOfShares":
              case "TotalPaidUpPremiumToShares":
              case "Remarks":
              case "location":
              case "TotalPaidUpCapital":
                return { wch: 35 };
              default:
                return { wch: 25 };
            }
          });

        worksheet["!cols"] = columnWidths;

        const headerRange = XLSX.utils.decode_range(worksheet["!ref"]);
        for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
          const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
          if (!worksheet[cellAddress]) continue;
          worksheet[cellAddress].s = {
            font: {
              bold: true,
            },
          };
        }

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Companies Report");

        XLSX.writeFile(
          workbook,
          `company_report_${getHongKongTimestamp()}.xlsx`
        );
      } else if (exportType === "PDF") {
        const tableHeaders = Object.keys(selectedFields)
          ?.filter((field) => selectedFields[field])
          ?.map((field) => formatHeaderLabel(field));

        const tableData = filteredData?.map((row) =>
          tableHeaders?.map((header) => row[header] || "----")
        );

        const columnWidths = [];
        const columnStyles = {};
        tableHeaders?.forEach((header, index) => {
          let width;
          switch (header) {
            case "ID":
              width = 10;
              break;
            case "Company Name":
              width = 40;
              break;
            case "Business Group":
            case "Business Nature":
            case "Incorporation Date":
            case "Directors":
            case "Chairman":
            case "Deputy Chairman":
            case "Managing Director":
            case "Deputy Managing Director":
            case "Representative Director":
            case "Resident Director":
            case "Legal Representative":
            case "Company Secretary":
            case "Statutory Auditor":
            case "Authorized Capital":
            case "Issued Paid Up Capital":
            case "Par Value Of Shares":
            case "Total Paid Up Premium To Shares":
            case "Remarks":
            case "Location":
              width = 50;
              break;
            case "Shareholders":
              width = 80;
              break;
            default:
              width = 20;
              break;
          }
          columnWidths.push(width);
          columnStyles[index] = { cellWidth: width };
        });

        const tableWidth = columnWidths.reduce((a, b) => a + b, 0);
        const doc = new jsPDF({
          orientation: "landscape",
          unit: "mm",
          format: [tableWidth + 20, 297],
        });

        autoTable(doc, {
          head: [tableHeaders],
          body: tableData,
          startY: 30,
          styles: { overflow: "linebreak", fontSize: 10 },
          headStyles: { fontStyle: "bold" },
          columnStyles: columnStyles,
          tableWidth: tableWidth,
        });
        doc.text("Companies Report", 14, 15);
        doc.save(`company_report_${getHongKongTimestamp()}.pdf`);
      }
    },
    [selectedNodes, nodes, formatHeaderLabel, htmlToPlainText]
  );

  // React Flow instance
  const [rfInstance, setRfInstance] = useState(null);
  const focusedOnceRef = useRef(false);
  const dispatchedOnceRef = useRef(false);

  // Node types - memoized to prevent re-renders
  const nodeTypes = useMemo(() => ({ custom: TextUpdaterNode }), []);

  const defaultEdgeOptions = useMemo(
    () => ({
      // animated: true,
      style: {
        stroke: "#110093ff",
        strokeWidth: 6,
      },
      zIndex: 1,
      type: "smoothstep",
    }),
    []
  );

  // Helper: read target ID from URL (?focusId=...), localStorage, or API rootId
  const getTargetIdFromEnv = useCallback(() => {
    if (data?.rootId) {
      return String(data.rootId);
    }
    // console.log("data", data);
    DEFAULT_FOCUS_ID = data?.rootId;

    // Final fallback (currently null)
    return DEFAULT_FOCUS_ID ?? undefined;
  }, [data]);

  // Helper: find node by id robustly
  const findNodeById = useCallback((nodesArray, id) => {
    if (!Array.isArray(nodesArray) || !id) return null;
    const idStr = String(id);
    return nodesArray.find((n) => {
      if (!n) return false;
      if (String(n.id) === idStr) return true;
      if (String(n._id) === idStr) return true;
      if (String(n.data?.nodeId) === idStr) return true;
      if (String(n.data?._id) === idStr) return true;
      return false;
    });
  }, []);

  // Focus group around target: target + children + parents + siblings
  const focusGroupAroundTarget = useCallback(
    (instance, nodesArray, targetId, opts = { duration: 600 }) => {
      if (!instance || !Array.isArray(nodesArray) || !targetId) return false;
      const target = findNodeById(nodesArray, targetId);
      if (!target) return false;

      // Collect neighbor ids
      const ids = new Set();
      ids.add(String(target.id));

      // Children
      const childIds = Array.isArray(target.children)
        ? target.children.map(String)
        : [];
      childIds.forEach((c) => ids.add(c));

      // Parents
      const parentIds = Array.isArray(target.parent)
        ? target.parent.map(String)
        : target.parent
          ? [String(target.parent)]
          : [];
      parentIds.forEach((p) => ids.add(p));

      // Siblings (first parent's children)
      if (parentIds.length > 0) {
        const parentNode = findNodeById(nodesArray, parentIds[0]);
        if (parentNode && Array.isArray(parentNode.children)) {
          parentNode.children.slice(0, 10).forEach((s) => ids.add(String(s)));
        }
      }

      // Build group nodes array
      const groupNodes = [target];
      for (const id of ids) {
        if (String(id) === String(target.id)) continue;
        const n = findNodeById(nodesArray, id);
        if (n) groupNodes.push(n);
        if (groupNodes.length >= 8) break;
      }

      // Calculate bounding box
      let minX = Infinity,
        minY = Infinity,
        maxX = -Infinity,
        maxY = -Infinity;

      for (const n of groupNodes) {
        let pos = n.position;
        if (!pos || typeof pos.x !== "number" || typeof pos.y !== "number") {
          const fx = n?.possssss?.xdata ?? n.position?.x;
          const fy = n?.possssss?.ydata ?? n.position?.y;
          if (typeof fx === "number" && typeof fy === "number") {
            pos = { x: fx, y: fy };
          }
        }
        if (!pos) continue;
        minX = Math.min(minX, pos.x);
        minY = Math.min(minY, pos.y);
        maxX = Math.max(maxX, pos.x + nodeWidth);
        maxY = Math.max(maxY, pos.y + nodeHeight);
      }

      if (!isFinite(minX) || !isFinite(minY)) {
        // Fallback: center on single node
        try {
          if (typeof instance.setCenter === "function") {
            instance.setCenter(
              target.position?.x ?? 0,
              target.position?.y ?? 0,
              Math.min(MAX_ZOOM, 0.6),
              { duration: opts.duration }
            );
          } else {
            instance.setViewport(
              {
                x: -(target.position?.x ?? 0) + window.innerWidth / 2,
                y: -(target.position?.y ?? 0) + window.innerHeight / 2,
                zoom: Math.min(MAX_ZOOM, 0.6),
              },
              { duration: opts.duration }
            );
          }
        } catch (e) {
          // ignore
        }
        return false;
      }

      const bboxWidth = Math.max(1, maxX - minX);
      const bboxHeight = Math.max(1, maxY - minY);

      // Compute zoom to fit bbox
      const usableW = window.innerWidth * VIEWPORT_PADDING;
      const usableH = window.innerHeight * VIEWPORT_PADDING;
      let scaleX = usableW / bboxWidth;
      let scaleY = usableH / bboxHeight;
      let zoom = Math.min(scaleX, scaleY);
      zoom = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, zoom));

      // Position target near top of viewport
      const desiredScreenX = window.innerWidth / 2;
      const desiredScreenY =
        window.innerHeight * TARGET_SCREEN_VERTICAL_FRACTION;

      const targetPos = target.position ?? { x: 0, y: 0 };
      const targetCenterX = targetPos.x + nodeWidth / 2;
      const targetCenterY = targetPos.y + nodeHeight / 2;

      const viewportX = desiredScreenX - targetCenterX * zoom;
      const viewportY = desiredScreenY - targetCenterY * zoom;

      try {
        if (typeof instance.setViewport === "function") {
          instance.setViewport(
            { x: viewportX, y: viewportY, zoom },
            { duration: opts.duration }
          );
        } else if (typeof instance.setCenter === "function") {
          const centerX = minX + bboxWidth / 2;
          const centerY = minY + bboxHeight / 2;
          instance.setCenter(centerX, centerY, zoom, {
            duration: opts.duration,
          });
        }
        return true;
      } catch (err) {
        console.error("focusGroupAroundTarget error:", err);
        return false;
      }
    },
    [findNodeById]
  );

  // Memoize getAllChildNodeIds to prevent recreation on every render
  const getAllChildNodeIds = useCallback(
    (nodeId) => {
      const childNodeIds = new Set();
      const queue = [nodeId];
      while (queue.length > 0) {
        const currentNodeId = queue.shift();
        if (!childNodeIds.has(currentNodeId)) {
          childNodeIds.add(currentNodeId);
          edges?.forEach((edge) => {
            if (
              edge.source === currentNodeId &&
              !childNodeIds.has(edge.target)
            ) {
              queue.push(edge.target);
            }
          });
        }
      }
      return Array.from(childNodeIds);
    },
    [edges]
  );

  /**
   * Helper: centralized visibility toggling for nodes
   * modes:
   *  - "onlySubtree": hide all except ids[] (used by plus button)
   *  - "showAll": show all nodes (used by minus button)
   *  - "toggleOne": toggle hidden for ids[] (optional, for future single-node toggle)
   */
  const toggleNodeHidden = useCallback(
    ({ mode, ids }) => {
      setNodes((prevNodes) =>
        prevNodes?.map((node) => {
          if (mode === "showAll") {
            return { ...node, hidden: false };
          }

          if (mode === "onlySubtree") {
            const inSubtree = ids?.includes(node.id);
            if (!inSubtree) {
              return {
                ...node,
                hidden: true,
                selected: false,
                data: {
                  ...node.data,
                  inSubtree: false,
                  isSelectedNode: false,
                },
              };
            }
            return node;
          }

          if (mode === "toggleOne") {
            const shouldToggle = ids?.includes(node.id);
            if (shouldToggle) {
              return { ...node, hidden: !node.hidden };
            }
            return node;
          }

          return node;
        })
      );
    },
    [setNodes]
  );

  // Initialize React Flow instance
  const handleInit = useCallback((instance) => {
    setDisplaying(true);
    if (!isMountedRef.current) return;
    setRfInstance(instance);
    try {
      if (typeof instance.setViewport === "function") {
        instance.setViewport({ x: 0, y: 0, zoom: 0.35 });
      } else if (typeof instance.setCenter === "function") {
        instance.setCenter(0, 0, 0.35);
      }
      setDisplaying(false);
    } catch (e) {
      // ignore
    }
  }, []);

  // Focus on target node once when ready
  useEffect(() => {
    if (!isMountedRef.current) return;
    if (focusedOnceRef.current) return;
    if (!rfInstance) return;
    if (!nodes || !nodes.length) return;
    setFocusing(true);

    if (data?.viewPermission) {
      console.log("view only permission - fit view");
      if (!reactFlowInstance || typeof reactFlowInstance.fitView !== "function")
        return;

      try {
        reactFlowInstance.fitView({ duration: 600 });
      } catch {
        // ignore runtime fitView errors
      }
      return;
    }
    const targetId = getTargetIdFromEnv();
    if (!targetId) {
      focusedOnceRef.current = true;
      return;
    }
    const ok = focusGroupAroundTarget(rfInstance, nodes, targetId, {
      duration: 600,
    });

    if (!ok && isMountedRef.current) {
      try {
        const node = findNodeById(nodes, targetId);
        if (node && isMountedRef.current) {
          if (typeof rfInstance.setCenter === "function") {
            rfInstance.setCenter(
              node.position?.x ?? 0,
              node.position?.y ?? 0,
              Math.min(MAX_ZOOM, 0.5),
              { duration: 600 }
            );
          } else {
            rfInstance.setViewport(
              {
                x: -(node.position?.x ?? 0) + window.innerWidth / 2,
                y: -(node.position?.y ?? 0) + window.innerHeight / 2,
                zoom: Math.min(MAX_ZOOM, 0.5),
              },
              { duration: 600 }
            );
          }
        }
      } catch (e) {
        // ignore
      }
    }

    if (isMountedRef.current) {
      focusedOnceRef.current = true;
    }
    setFocusing(false);
  }, [
    rfInstance,
    nodes,
    focusGroupAroundTarget,
    getTargetIdFromEnv,
    findNodeById,
  ]);

  // Handle plus button click - show only child nodes
  useEffect(() => {
    if (!isMountedRef.current) return;
    if (plusButton && clickedNodeId) {
      const childNodes = getAllChildNodeIds(clickedNodeId);
      if (isMountedRef.current) {
        toggleNodeHidden({ mode: "onlySubtree", ids: childNodes });
      }
      const timeoutId = setTimeout(() => {
        if (isMountedRef.current && reactFlowInstance) {
          reactFlowInstance.fitView({
            duration: 50,
          });
        }
      }, 50);
      timeoutRefs.current.push(timeoutId);
      if (isMountedRef.current) {
        dispatch(
          setPlusClicked({
            click: false,
            id: clickedNodeId,
          })
        );
      }
    }
  }, [
    dispatch,
    plusButton,
    clickedNodeId,
    getAllChildNodeIds,
    toggleNodeHidden,
    reactFlowInstance,
  ]);

  // Handle minus button click - show all nodes
  useEffect(() => {
    if (!isMountedRef.current) return;
    if (minusButton) {
      if (isMountedRef.current) {
        toggleNodeHidden({ mode: "showAll" });
      }
      const timeoutId = setTimeout(() => {
        if (isMountedRef.current && reactFlowInstance) {
          reactFlowInstance.fitView({
            duration: 50,
          });
        }
      }, 50);
      timeoutRefs.current.push(timeoutId);
      if (isMountedRef.current) {
        dispatch(
          setMinusClicked({
            click: false,
          })
        );
      }
    }
  }, [dispatch, minusButton, toggleNodeHidden, reactFlowInstance]);

  const [lock, setLock] = useState(true);

  // Memoize controlsRef to prevent unnecessary re-renders
  const controlsRef = useCallback(() => {
    setLock((prevLock) => !prevLock);
  }, []);

  const handleSelectAllChange = useCallback(
    (event) => {
      if (!isMountedRef.current) return;
      const selecteds = nodes?.map((node) => node.data);
      if (event.target.checked) {
        dispatch(setSelectedNodes(selecteds));
        setIsAllSelected(true);
      } else {
        dispatch(clearSelectedNodes());
        setIsAllSelected(false);
      }
    },
    [nodes, dispatch]
  );

  // Handle search - debounced to prevent excessive updates
  const handleSearchChange = useCallback(
    (event) => {
      const query = event.target.value;
      setSearchValue(query);

      // Clear previous timeout
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }

      // Debounce search to prevent excessive state updates
      searchTimeoutRef.current = setTimeout(() => {
        if (!isMountedRef.current) return;
        const queryLower = query.toLowerCase();

        if (queryLower.length > 0) {
          setNodes((nds) =>
            nds?.map((node) => {
              const matches = node?.data?.label
                ?.toLowerCase()
                ?.includes(queryLower);
              return { ...node, hidden: !matches };
            })
          );

          // Adjust the view
          const timeoutId = setTimeout(() => {
            if (isMountedRef.current && reactFlowInstance) {
              reactFlowInstance.fitView({
                duration: 50,
              });
            }
          }, 100);
          timeoutRefs.current.push(timeoutId);
        } else {
          // If input is cleared, show all nodes
          setNodes((nds) =>
            nds?.map((node) => ({
              ...node,
              hidden: false,
            }))
          );
        }
      }, 300); // 300ms debounce
    },
    [setNodes, reactFlowInstance]
  );

  // Dispatch to Redux once when nodes/edges are ready
  useEffect(() => {
    if (!isMountedRef.current) return;
    if (dispatchedOnceRef.current) return;
    if (!nodes?.length || !edges) return;

    dispatch(Addnodepositioned(nodes));
    dispatch(Addedgepositioned(edges));
    dispatchedOnceRef.current = true;
  }, [dispatch, nodes, edges]);
  // Loading state - we no longer early return on fetchingNodes; overlay handles it
  if (!data || !(Array.isArray(data?.nodes) && data?.nodes.length > 0) || isError) {
    return (
      <Box
        height="100vh"
        width="100vw"
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            padding: 4,
            backgroundColor: "white",
            borderRadius: "16px",
            boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
            maxWidth: 500,
          }}
        >
          <Typography
            sx={{
              fontSize: "64px",
              marginBottom: 2,
            }}
          >
            📊
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              marginBottom: 1,
              color: "#333",
            }}
          >
            {isError ? "Error Loading Data" : "No Data Available"}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#666",
              marginBottom: 2,
              lineHeight: 1.6,
            }}
          >
            {isError
              ? "We encountered an error while loading the organization hierarchy. Please try refreshing the page or contact support if the issue persists."
              : "The organization hierarchy data is currently unavailable. Please check back shortly or refresh the page."}
          </Typography>
          <Box sx={{ display: "flex", gap: 2, justifyContent: "center", mt: 3 }}>
            <button
              onClick={() => window.location.reload()}
              className="btn btn-primary"
              style={{
                padding: "10px 24px",
                borderRadius: "8px",
                fontWeight: "500",
              }}
            >
              🔄 Refresh Page
            </button>
            <button
              onClick={() => window.history.back()}
              className="btn btn-outline-secondary"
              style={{
                padding: "10px 24px",
                borderRadius: "8px",
                fontWeight: "500",
              }}
            >
              ← Go Back
            </button>
          </Box>
        </Box>
      </Box>
    );
  }

  // ---------- RENDER ----------
  return (
    <>
      {/* Overlay loader: shows until graphReady */}
      {!graphReady && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            zIndex: 100000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(255,255,255,0.85)",
            backdropFilter: "blur(4px)",
          }}
        >
          <div
            style={{
              width: "min(920px, 92%)",
              maxWidth: 920,
              padding: 18,
              borderRadius: 10,
              boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
              background: "#ffffff",
              textAlign: "left",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 12,
              }}
            >
              <div>
                <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 6 }}>
                  Preparing chart...
                </div>
                <div style={{ fontSize: 13, color: "#444" }}>
                  {/* show active stages as text */}
                  {fetchingNodes && <span>Fetching nodes</span>}
                  {layouting && (
                    <span>{fetchingNodes ? " • " : ""}Layouting</span>
                  )}
                  {renderingNodes && (
                    <span>
                      {fetchingNodes || layouting ? " • " : ""}Rendering nodes
                    </span>
                  )}
                  {focusing && (
                    <span>
                      {fetchingNodes || layouting || renderingNodes
                        ? " • "
                        : ""}
                      Focusing view
                    </span>
                  )}
                </div>
              </div>

              <div style={{ minWidth: 90, textAlign: "right" }}>
                <div style={{ fontSize: 18, fontWeight: 700 }}>{progress}%</div>
              </div>
            </div>

            {/* progress bar */}
            <div style={{ marginTop: 12 }}>
              <div
                style={{
                  width: "100%",
                  height: 12,
                  background: "#f1f3f6",
                  borderRadius: 8,
                  overflow: "hidden",
                }}
              >
                <div
                  role="progressbar"
                  aria-valuenow={progress}
                  style={{
                    width: `${progress}%`,
                    height: "100%",
                    transition: "width 20ms linear",
                    background: "linear-gradient(90deg,#21C4FF,#6B21FF)",
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: 8,
                }}
              >
                <div style={{ fontSize: 12, color: "#666" }}>
                  {progress < 30 && "Starting"}
                  {progress >= 30 && progress < 50 && "Processing layout"}
                  {progress >= 50 && progress < 70 && "Rendering nodes"}
                  {progress >= 50 && progress < 70 && "setting"}
                  {progress >= 95 && "Finalizing"}
                </div>
                <div style={{ fontSize: 12, color: "#666" }}>
                  {progress < 100 ? "Please wait..." : "Done"}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}


      {reportingModalOpen && (
        <GenerateReportSelectorModal
          open={reportingModalOpen}
          handleClose={handleReportingModalClose}
          handleCloseModalSubmit={(fields) => {
            handleReportingModalClose();
            reportGeneration(fields);
          }}
        />
      )}
      {open && (
        <NodeDetailSelectorModal
          open={open}
          handleClose={handleClose}
          nodes={selectedNodes}
          handleCloseModalSubmit={(fields, exportType) => {
            generateReport(fields, exportType);
          }}
        />
      )}

      <ReactFlow
        maxZoom={MAX_ZOOM}
        minZoom={MIN_ZOOM}
        defaultViewport={{ zoom: 0.35 }}
        defaultEdgeOptions={defaultEdgeOptions}
        edges={edges}
        nodes={nodes}
        onInit={handleInit}
        nodeTypes={nodeTypes}
        panOnDrag
        panOnScroll
        zoomOnScroll
        // Performance optimizations - keep these disabled for speed
        nodesDraggable={false}
        nodesConnectable={false}
        elementsSelectable={true}
        // onlyRenderVisibleElements
        selectionOnDrag={true}
        proOptions={{ hideAttribution: true }}
        // Memory optimization: prevent unnecessary re-renders
        deleteKeyCode={null}
        multiSelectionKeyCode={null}
        connectionRadius={20}
        // Prevent React Flow from keeping old instances in memory
        fitViewOnInit={false}
        style={{
          opacity: graphReady ? 1 : 0,
          transition: "opacity 200ms ease-out",
          pointerEvents: graphReady ? "auto" : "none",
        }}
      >
        <MiniMap
          nodeColor={(n) => {
            if (n.style?.background) return n.style.background;
            return "#1a192b";
          }}
          nodeBorderRadius={2}
          nodeStrokeWidth={3}
          zoomable
          pannable
        />
        <Controls onInteractiveChange={controlsRef} />
        <div
          style={{
            position: "absolute",
            top: 12,
            left: 12,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <DownloadButton
            rfInstance={rfInstance}
            selectedNodes={selectedNodes}
            onDownload={onDownload}
            isExporting={isExporting}
            // nodes={nodes}
            setNodes={setNodes}
            // edges={edges}
            setEdges={setEdges}
          />
        </div>
      </ReactFlow>

      {/* Top-right controls container: all actions in a single horizontal line */}
      <div
        style={{
          position: "fixed",
          top: 82,
          right: 12,
          left: "auto",
          zIndex: 100,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 12,
          flexWrap: "nowrap",
          pointerEvents: "auto",
          background: "rgba(255,255,255,0.9)",
          padding: "8px 12px",
          borderRadius: 8,
          boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
        }}
      >
        {/* Download button (use rfInstance) */}

        {/* Checkbox before Generate Report */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <Checkbox
            checked={isAllSelected}
            onChange={handleSelectAllChange}
            inputProps={{ "aria-label": "Select all organizations" }}
            sx={{
              transform: "scale(1.15)",
              "& .MuiSvgIcon-root": { fontSize: 22 },
            }}
          />
        </div>

        {/* Generate Report */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <button
            style={{
              pointerEvents: "auto",
            }}
            className="btn btn-outline-primary"
            onClick={() => {
              if (selectedNodes?.length > 0) {
                handleOpen();
              } else {
                toast.error(
                  "Please Select at least one organization for report generation"
                );
              }
            }}
          >
            Generate Report
          </button>
        </div>

        {/* Search pushed to the right on wide screens */}
        <div style={{ marginLeft: "auto", minWidth: 160, maxWidth: 420 }}>
          <TextField
            label="Search"
            size="small"
            variant="outlined"
            value={searchValue}
            onChange={handleSearchChange}
            sx={{ width: "100%" }}
          />
        </div>
      </div>

      {/* Ownership legend: separate fixed block on right to avoid overlap */}
      <div style={{ position: "fixed", top: 140, right: 15, zIndex: 100 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "start",
            width: 300,
            padding: 2,
            borderRadius: "8px",
            backgroundColor: "#f9f9f9",
            boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
          }}
        >
          <Typography
            sx={{ textAlign: "center", fontWeight: "bold", fontSize: "14px" }}
          >
            Ownership
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
            <Box
              sx={{
                width: 20,
                height: 20,
                backgroundColor: "yellow",
                borderRadius: 1,
              }}
            />
            <Typography sx={{ fontSize: 12 }}>
              Wholly-owned Subsidiaries = 100%
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
            <Box
              sx={{
                width: 20,
                height: 20,
                backgroundColor: "#ADD8E6",
                borderRadius: 1,
              }}
            />
            <Typography sx={{ fontSize: 12 }}>
              Non-wholly-owned Subsidiaries = 50% {"<"} X {"<"} 100%
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
            <Box
              sx={{
                width: 20,
                height: 20,
                backgroundColor: "#FFB6C1",
                borderRadius: 1,
              }}
            />
            <Typography sx={{ fontSize: 12 }}>
              Associated Companies = 20% ≤ X ≤ 50%
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
            <Box
              sx={{
                width: 20,
                height: 20,
                backgroundColor: "red",
                borderRadius: 1,
              }}
            />
            <Typography sx={{ fontSize: 12 }}>
              Branches & Subsidiaries pending closure
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
            <Box
              sx={{
                width: 20,
                height: 20,
                backgroundColor: "#b7e4c7",
                borderRadius: 1,
              }}
            />
            <Typography sx={{ fontSize: 12 }}>Branches</Typography>
          </Box>
        </Box>
      </div>
    </>
  );
};

// Export memoized component
export const D3_View = React.memo(D3_ViewComponent);
